import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Loading } from 'app/components/Wrappers';
import ReportContent from "../ReportContent";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";

const ReportPage = () => {
    const { reportId } = useParams<{ reportId: string }>();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [report, setReport] = useState({});

    useEffect(() => {
        schedulingFetchGet<any[]>(`reports/${reportId}`, {})
            .then((report) => {
                setReport(report);
                setLoading(false);
            })
            .catch(() => {
                history.push('/404');
            });
    }, [reportId]);

    return loading ? <Loading loadType="spinner" /> : <ReportContent report={report} />;

};

export default ReportPage;
